<template>
  <div class="prescription">
    <div class="presTitle">
      <p>宜贰叁互联网医院</p>
      <p>电子处方笺</p>
    </div>
    <ul class="Personaldetail">
      <li>
        <span>
          <span>NO.</span>
          <span>{{ list.pref }}</span>
        </span>
      </li>
      <li>
        <span>
          <span>处方日期:</span>
          <span>{{ list.outPrescriptionTime }}</span>
        </span>
      </li>
      <li>
        <span>
          <span>姓名：</span>
          <span>{{ list.patientName }}</span>
        </span>
        <span>科室：内科</span>
      </li>
      <li>
        <span>诊断结果：</span>
        <span>{{ list.diagnosis }}</span>
      </li>
    </ul>

    <p class="brP">
      <span>Rp:</span>
    </p>
    <div v-for="(item,index) in list.detailList" :key="index" class="tablelist">
      <div class="tableli">
        <span>{{ index+1 }}.{{ item.productName }}</span>
        <span>
          <span>{{ item.attributeSpecification + "&nbsp;*&nbsp;" + item.quantity }}</span>
          <span>{{ item.directions }}，一次{{ item.singleDoseValue }}{{ item.singleUnit }}，{{ item.useFrequency }}</span>
        </span>
      </div>
    </div>
    <div class="prebottom">
      <p>
        <span>医师:</span>
        <span>
          <img v-if="list.physicianSign" :src="`data:image/jpeg;base64,${list.physicianSign}`" />
        </span>
      </p>
      <p>
        <span>药师:</span>
        <span>
          <img v-if="list.pharmacistSign" :src="`data:image/jpeg;base64,${list.pharmacistSign}`" />
        </span>
      </p>
    </div>
  </div>
</template>
<script>
// import { getPreDetail } from '../api/index'
import { parseTime } from '../utils/index'

export default {
  filters: {
    filterPrice(item) {
      switch (item) {
        case 'ONETHIRD':
          return '1/3'
        case 'ONESECOND':
          return '1/2'
        case 'ONETOONE':
          return 1
        case 'ONETOTWO':
          return 2
        case 'ONETOTHREE':
          return 3
        case 'ONETOFOUR':
          return 4
        case 'ONETOFIVE':
          return 5
        case 'ONETOSIX':
          return 6
        case 'ONETOSEVEN':
          return 7
        case 'ONETOEIGHT':
          return 8
        case 'ONETONINE':
          return 9
        case 'ONETOTEN':
          return 10
      }
    }
  },
  props: {
    // 从上个页面传过来的商品编号
    // listPre: {
    //   type: String,
    //   default: ''
    // },
    list: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      // list: {},
      NOW_TIME: '',
      // 药师签名
      pharmacistSignUrl: '',
      physicianSignUrl: ''
      // 医师签名
    }
  },
  watch: {
    list(res) {
      // const res = await getPreDetail({ guid: this.listPre })
      this.list = res
      this.pharmacistSignUrl = res.pharmacistSign // 药师签名
      this.physicianSignUrl = res.physicianSign // 医师签名
      // console.log('获取签名', res.pharmacistSign, res.physicianSign)
    }
  },
  async created() {
    // const res = await getPreDetail({ guid: this.listPre })
    // this.list = res
    // this.pharmacistSignUrl = res.pharmacistSign // 药师签名
    // this.physicianSignUrl = res.physicianSign // 医师签名
    // console.log('获取签名', res.pharmacistSign, res.physicianSign)
    // this.NOW_TIME = parseTime(this.list.outPrescriptionTime || new Date(), '{y}-{m}-{d}')
  },
  mounted() {},
  methods: {}
}
</script>
<style scoped>
/* 整体圆角 */
.prescription {
  border-radius: 0 0 14px 14px;
  background: #ffffff;
  margin: 0 15px;
}
/* 调整头部 */
.presTitle {
  width: 345px;
  height: 80px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.presTitle p {
  line-height: 25px;
  margin: 0;
  font-size: 18px;
  font-weight: 550;
  color: #333;
}

/* 调整ul */
.Personaldetail {
  display: flex;
  flex-direction: column;
  font-size: 15px;
  width: 335px;
  padding: 0 15px 8px 15px;
  box-sizing: border-box;
  border-bottom: 1px solid #e1e1e1;
}
.Personaldetail li {
  line-height: 28px;
  color: #333;
  font-weight: 400;
  margin-bottom: 5px;
}

.Personaldetail li:not(:last-child) {
  display: flex;
  justify-content: space-between;
}
.Personaldetail li span:nth-of-type(1) {
  width: 100%;
}
.Personaldetail li span:nth-of-type(2) {
  width: 169px;
}
/* 调整brP */
.brP {
  width: 335px;
  margin: 8px 0;
  padding-left: 10px;
  box-sizing: border-box;
}
/* 调整药品 */
.tablelist {
  width: 335px;
  padding: 0 5px 10px 5px;
  box-sizing: border-box;
}
.tableli {
  font-size: 14px;
  font-weight: 400;
  color: #333;
  margin-bottom: 7px;
  display: flex;
  word-break: break-all;
  padding-left: 10px;
  box-sizing: border-box;
}
.tableli span:nth-of-type(1) {
  width: 140px;
  display: inline-block;
  margin-right: 7px;
}
.tableli span:nth-of-type(2) {
  width: 178px;
  display: inline-block;
}
.tableli span:nth-of-type(2) span:not(:last-child) {
  margin-bottom: 5px;
}
/* 签名 */
.prebottom {
  width: 325px;
  padding: 10px 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #e1e1e1;
}
.prebottom p {
  margin: 0;
  display: inline-block;
  padding: 0;
  box-sizing: border-box;
  font-size: 15px;
  font-weight: 400;
  color: #333;
}
.prebottom img {
  width: 45px;
  height: 30px;
  vertical-align: middle;
}
.prebottom p span:nth-of-type(1) {
  margin-right: 5px;
}
</style>
